<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.allocates'), $t('text.list')]">
        <el-dropdown
          v-if="Permit.canActionsChargeEdition('wmsInventoryAllocateIn')"
          menu-align="start"
          trigger="click"
        >
          <el-button type="primary" size="mini">
            {{ $t("allocateTypes.in") }}
            <i class="el-icon-caret-bottom el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="shop of shopsManage" :key="shop.id">
              <div
                @click="$router.push('/normal/wms/allocates/new-in/' + shop.id)"
              >
                {{ shop.name }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>

        <date-range
          v-model="searchForm"
          type="datetime"
          field="applyAt"
          :start-placeholder="$t('rules.startAt', [$t('allocate.applyAt')])"
          :end-placeholder="$t('rules.endAt', [$t('allocate.applyAt')])"
        />
        <date-range
          v-model="searchForm"
          type="datetime"
          field="acceptAt"
          :start-placeholder="$t('rules.startAt', [$t('allocate.acceptAt')])"
          :end-placeholder="$t('rules.endAt', [$t('allocate.acceptAt')])"
        />
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              v-if="Permit.canActionsChargeEdition('wmsAllocateVerify')"
              type="primary"
              size="mini"
              class="mgr10"
              @click="batchAccept"
            >
              {{ $t("action.accept") }}
            </el-button>

            <el-dropdown @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">{{
                  $t("action.downLoadChecked")
                }}</el-dropdown-item>
                <el-dropdown-item command="search">{{
                  $t("action.downLoadSearch")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="mgl10" @command="print">
              <el-button type="default" size="mini">
                {{ $t("action.print") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="printList1">{{
                  $t("action.printList1")
                }}</el-dropdown-item>
                <el-dropdown-item command="printList2">{{
                  $t("action.printList2")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>

      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true }"
        :loading="loading"
        id="stockInsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85px"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.productImages_" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('allocate.serialNo')"
          min-width="140"
        >
          <template v-slot="{ row }">
            {{ row.serialNo }}
            <div :class="row.type == 'in' ? 'green' : 'orange'" class="font10">
              {{ $t("allocateTypes." + row.type) }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">
              {{ row.categoryName_ }}
              <span v-if="row.productBrand_ != null">/</span>
              {{ row.productBrand_ }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="color"
          :title="$t('product.color')"
          min-width="80"
        />
        <vxe-table-column
          field="size"
          :title="$t('product.size')"
          min-width="80"
        />
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="70"
        />
        <vxe-table-column
          field="workflowState"
          :title="$t('text.workflowState')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <state-label :state="row.workflowState">
              {{ $t("allocateWorkflowState." + row.workflowState) }}
            </state-label>
            <div v-if="row.workflowState == 'cancel'" class="font10">
              <div class="font10">{{ row.cancelName }}</div>
              <div class="font10">{{ row.cancelAt }}</div>
              <div class="font10">
                <raw-html-limit-number
                  :content="row.cancelReason"
                  :number="10"
                />
              </div>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="applyDepartName"
          :title="$t('allocate.applyDepartInfo')"
          min-width="160"
        >
          <template v-slot="{ row }">
            {{ row.applyDepartName }}
            <div class="font10">
              {{ row.applicantName }} 于 {{ row.applyAt }}
            </div>
            <raw-html-limit-number :content="row.applyRemark" :number="20" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="acceptDepartName"
          :title="$t('allocate.acceptDepartInfo')"
          min-width="160"
        >
          <template v-slot="{ row }">
            {{ row.acceptDepartName }}
            <span v-if="row.workflowState == 'rejected'">
              <div class="font10">
                {{ row.rejecterName }} 于 {{ row.rejectAt }}
              </div>
              <div class="font10">
                <raw-html-limit-number
                  :content="row.rejectReason"
                  :number="20"
                />
              </div>
            </span>
            <span v-else>
              <div class="font10">{{ row.accepterName }}{{ row.acceptAt }}</div>
              <raw-html-limit-number :content="row.acceptRemark" :number="20" />
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="inOperatorName"
          :title="$t('allocate.inOperatorName')"
          width="80"
        />
        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="90"
          fixed="right"
        >
          <template v-slot="{ row, rowIndex }">
            <div
              v-if="
                row.type == 'in' &&
                row.workflowState == 'applying' &&
                (Permit.wmsManageShopIds().includes(row.applyDepartId) ||
                  Permit.currentUser().admin) &&
                Permit.canActionsChargeEdition('wmsAllocateManage')
              "
            >
              <el-button type="text" size="mini" @click="edit(row, rowIndex)">{{
                $t("text.edit")
              }}</el-button>
              <el-button type="text" size="mini" @click="deleteRow(row)">{{
                $t("text.delete")
              }}</el-button>
            </div>

            <div
              v-if="
                row.type == 'in' &&
                row.workflowState == 'applying' &&
                (Permit.wmsManageShopIds().includes(row.acceptDepartId) ||
                  Permit.currentUser().admin)
              "
            >
              <el-button
                v-if="Permit.canActionsChargeEdition('wmsAllocateVerify')"
                type="text"
                size="mini"
                @click="accept(row, rowIndex)"
                >{{ $t("action.accept") }}</el-button
              >
              <el-button
                v-if="Permit.canActionsChargeEdition('wmsAllocateVerify')"
                type="text"
                size="mini"
                @click="reject(row, rowIndex)"
                >{{ $t("action.reject") }}</el-button
              >
              <!-- <div
                v-if="
                  Permit.canActionsChargeEdition('wmsAllocateVerifyAndPick')
                "
              >
                <el-button
                  type="text"
                  size="mini"
                  @click="acceptAndPick(row, rowIndex)"
                  >{{ $t("action.acceptAndPick") }}</el-button
                >
              </div> -->
            </div>
            <div
              v-if="
                row.workflowState == 'picking' &&
                Permit.canActionsChargeEdition('wmsAllocateManage') &&
                (Permit.currentUser().admin ||
                  (row.type == 'in' &&
                    Permit.wmsManageShopIds().includes(row.applyDepartId)) ||
                  (row.type == 'out' &&
                    Permit.wmsManageShopIds().includes(row.applyDepartId)))
              "
            >
              <el-button
                type="text"
                size="mini"
                @click="cancel(row, rowIndex)"
                >{{ $t("order.cancel") }}</el-button
              >
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="50%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="80px">
        <fieldset class="mgb15">
          <legend>{{ $t("allocate.applyDepartInfo") }}</legend>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('menu.warehouses')"
                :prop="'applyDepartId'"
              >
                {{ editObj._applyDepartName }}&nbsp;
                <small>
                  <span v-if="currentRowInvInfo != null"
                    >(库存:{{ currentRowInvInfo.quantity }}/锁定:{{
                      currentRowInvInfo.totalLock
                    }})</span
                  >
                  <span v-else>(库存不存在)</span>
                </small>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('allocate.allocateType')">{{
                $t("allocateTypes." + editObj._type)
              }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('text.quantity')"
                :prop="'quantity'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('text.quantity')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="editObj.quantity"
                  @blur="checkAllocateQuantityEdit"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :prop="'applyRemark'"
                :label="$t('allocate.applyRemark')"
              >
                <el-input
                  size="small"
                  v-model.trim="editObj.applyRemark"
                  type="textarea"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
        <fieldset class="mgb15">
          <legend>{{ $t("allocate.acceptDepartInfo") }}</legend>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('menu.warehouses')"
                :prop="'acceptDepartId'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('menu.warehouses')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  size="small"
                  v-model="editObj.acceptDepartId"
                  @change="checkAllocateQuantityEdit"
                >
                  <el-option
                    v-for="invshop in shopsAllocate"
                    :key="invshop.shopId"
                    :label="invshop.text"
                    :value="invshop.shopId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 受理 -->
    <el-dialog
      :title="$t('action.accept')"
      :close-on-click-modal="false"
      :visible.sync="acceptDF"
      width="30%"
    >
      <el-form ref="acceptObjForm" :model="acceptObj" label-width="100px">
        <el-form-item
          :label="$t('allocate.acceptDepartName')"
          :prop="'applyDepartId'"
        >
          {{ acceptObj._acceptDepartName }}
          <small>
            <span v-if="currentRowInvInfo != null"
              >(库存:{{ currentRowInvInfo.quantity }}/锁定:{{
                currentRowInvInfo.totalLock
              }})</span
            >
            <span v-else>(库存不存在)</span>
          </small>
        </el-form-item>

        <el-form-item
          :label="'其他调拨单待受理数量'"
          :prop="'_unAcceptAllocateQuantity'"
          label-width="160px"
        >
          {{ acceptObj._unAcceptAllocateQuantity }}
        </el-form-item>
        <el-form-item
          :label="$t('text.quantity')"
          :prop="'quantity'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            :placeholder="acceptObj._maxQuantity"
            v-model.trim="acceptObj.quantity"
          />
        </el-form-item>
        <el-form-item
          :prop="'operateRemark'"
          :label="$t('allocate.acceptRemark')"
        >
          <el-input
            size="small"
            v-model.trim="acceptObj.operateRemark"
            type="textarea"
          />
        </el-form-item>
        <el-form-item :prop="'_andPickDF'" :label="$t('stock.andPick')">
          <el-checkbox v-model="acceptObj._andPickDF" />
        </el-form-item>
        <el-form-item
          v-if="acceptObj._andPickDF"
          :label="$t('stock.shelf')"
          :prop="'shelfId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('stock.shelf')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="acceptObj.shelfId"
            @change="selectAcceptAndPickShelf"
          >
            <el-option
              v-for="shelf in currentRowInvShelfs"
              :key="shelf.shelfId"
              :label="shelf.shelfName + '(' + shelf.quantity + ')'"
              :value="shelf.shelfId"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="acceptDoing"
          size="small"
          @click="acceptSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="acceptDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 拒绝 -->
    <el-dialog
      :title="$t('action.reject')"
      :close-on-click-modal="false"
      :visible.sync="rejectDF"
      width="30%"
    >
      <el-form ref="rejectForm" :model="rejectObj">
        <el-form-item :prop="'operateRemark'">
          <el-input
            size="small"
            v-model.trim="rejectObj.operateRemark"
            type="textarea"
            :placeholder="$t('allocate.rejectReason')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="rejectDoing"
          size="small"
          @click="rejectSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="rejectDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 取消 -->
    <el-dialog
      :title="$t('order.cancel')"
      :close-on-click-modal="false"
      :visible.sync="cancelDF"
      width="30%"
    >
      <el-form ref="cancelForm" :model="cancelObj">
        <el-form-item :prop="'cancelReason'">
          <el-input
            size="small"
            v-model.trim="cancelObj.cancelReason"
            type="textarea"
            :placeholder="$t('order.cancelReason')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="cancelDoing"
          size="small"
          @click="cancelSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="cancelDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <div id="printList1" style="display: none">
      <table
        style="
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #000;
          word-wrap: break-word;
          word-break: break-all;
          font-size: 10px;
        "
      >
        <tr style="border: 1px solid #000">
          <td style="border: 1px solid #000; width: 60px">
            {{ $t("allocate.serialNo") }}
          </td>
          <td style="border: 1px solid #000; width: 60px">
            {{ $t("product.productNo") }}
          </td>
          <td style="border: 1px solid #000; width: 50px">
            {{ $t("product.color") }}
          </td>
          <td style="border: 1px solid #000; width: 50px">
            {{ $t("product.size") }}
          </td>
          <td style="border: 1px solid #000; width: 40px">
            {{ $t("text.quantity") }}
          </td>
          <td style="border: 1px solid #000; width: 50px">
            {{ $t("text.workflowState") }}
          </td>
          <td style="border: 1px solid #000; width: 60px">
            {{ $t("allocate.applyDepartInfo") }}
          </td>
          <td style="border: 1px solid #000; width: 60px">
            {{ $t("text.type") }}
          </td>
          <td style="border: 1px solid #000; width: 60px">
            {{ $t("allocate.acceptDepartInfo") }}
          </td>
          <td style="border: 1px solid #000; width: 60px">
            {{ $t("allocate.inOperatorName") }}
          </td>
        </tr>
        <tr
          v-for="(c, index) in selectRecords"
          :key="index"
          style="border: 1px solid #000"
        >
          <td style="border: 1px solid #000">{{ c.serialNo }}</td>
          <td style="border: 1px solid #000">
            {{ c.productNo }}
            <div>
              {{ c.categoryName_ }}
              <span v-if="c.productBrand_ != null">/</span>
              {{ c.productBrand_ }}
            </div>
          </td>

          <td style="border: 1px solid #000">{{ c.color }}</td>
          <td style="border: 1px solid #000">{{ c.size }}</td>

          <td style="border: 1px solid #000">{{ c.quantity }}</td>
          <td style="border: 1px solid #000">
            {{ $t("allocateWorkflowState." + c.workflowState) }}
          </td>
          <td style="border: 1px solid #000">
            {{ c.applyDepartName }}
            <div>{{ c.applicantName }} 于 {{ c.applyAt }}</div>
            <raw-html :content="c.applyRemark" />
          </td>
          <td style="border: 1px solid #000">
            {{ $t("allocateTypes." + c.type) }}
          </td>
          <td style="border: 1px solid #000">
            {{ c.acceptDepartName }}
            <span v-if="c.workflowState == 'rejected'">
              <div>{{ c.rejecterName }} 于 {{ c.rejectAt }}</div>
              <div>{{ c.rejectReason }}</div>
            </span>
            <span v-else>
              <div>{{ c.accepterName }}{{ c.acceptAt }}</div>
              <raw-html :content="c.acceptRemark" />
            </span>
          </td>
          <td style="border: 1px solid #000">{{ c.inOperatorName }}</td>
        </tr>
      </table>
    </div>
    <div id="printList2" style="display: none">
      <div style="text-align: center">{{ $t("menu.allocates") }}</div>
      <table
        style="
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #000;
          word-wrap: break-word;
          word-break: break-all;
          font-size: 10px;
        "
      >
        <div v-for="(c, index) in selectRecords" :key="index">
          <tr style="border: 1px solid #000">
            <td style="border: 1px solid #000; width: 60px; font-weight: bold">
              {{ $t("allocate.applyRemark") }}
            </td>
            <td colspan="11">
              <raw-html :content="c.applyRemark" />
            </td>
          </tr>
          <tr style="border: 1px solid #000">
            <td style="border: 1px solid #000; font-weight: bold">
              {{ $t("allocate.serialNo") }}
            </td>
            <td style="border: 1px solid #000" colspan="5">{{ c.serialNo }}</td>
            <td style="border: 1px solid #000; font-weight: bold">
              {{ $t("allocate.allocateType") }}
            </td>
            <td style="border: 1px solid #000" colspan="5">
              {{ $t("allocateTypes." + c.type) }}
            </td>
          </tr>
          <tr style="border: 1px solid #000">
            <td style="border: 1px solid #000; font-weight: bold" colspan="2">
              {{ $t("product.brand") }}
            </td>
            <td style="border: 1px solid #000; font-weight: bold" colspan="2">
              {{ $t("product.category") }}
            </td>
            <td style="border: 1px solid #000; font-weight: bold" colspan="2">
              {{ $t("product.productNo") }}
            </td>
            <td style="border: 1px solid #000; font-weight: bold" colspan="2">
              {{ $t("product.color") }}
            </td>
            <td style="border: 1px solid #000; font-weight: bold" colspan="2">
              {{ $t("product.size") }}
            </td>
            <td style="border: 1px solid #000; font-weight: bold" colspan="2">
              {{ $t("text.quantity") }}
            </td>
          </tr>
          <tr style="border: 1px solid #000">
            <td style="border: 1px solid #000" colspan="2">
              {{ c.productBrand_ }}
            </td>
            <td style="border: 1px solid #000" colspan="2">
              {{ c.categoryName_ }}
            </td>
            <td style="border: 1px solid #000" colspan="2">
              {{ c.productNo }}
            </td>
            <td style="border: 1px solid #000" colspan="2">{{ c.color }}</td>
            <td style="border: 1px solid #000" colspan="2">{{ c.size }}</td>
            <td style="border: 1px solid #000" colspan="2">{{ c.quantity }}</td>
          </tr>
          <tr style="border: 1px solid #000">
            <td
              style="
                border: 1px solid #000;
                border-bottom: 1px solid black;
                font-weight: bold;
              "
            >
              {{ $t("allocate.applyAt") }}
            </td>
            <td
              style="
                border: 1px solid #000;
                border-bottom: 1px solid black;
                width: 80px;
              "
            >
              {{ c.applyAt }}
            </td>
            <td
              style="
                border: 1px solid #000;
                border-bottom: 1px solid black;
                font-weight: bold;
              "
            >
              {{ $t("allocate.applyDepart") }}
            </td>
            <td style="border: 1px solid #000; border-bottom: 1px solid black">
              {{ c.applyDepartName }}
            </td>
            <td
              style="
                border: 1px solid #000;
                border-bottom: 1px solid black;
                font-weight: bold;
              "
            >
              {{ $t("allocate.applyName") }}
            </td>
            <td style="border: 1px solid #000; border-bottom: 1px solid black">
              {{ c.applicantName }}
            </td>

            <td
              style="
                border: 1px solid #000;
                border-bottom: 1px solid black;
                font-weight: bold;
              "
            >
              {{ $t("allocate.acceptAt") }}
            </td>
            <td style="border: 1px solid #000; border-bottom: 1px solid black">
              {{ c.acceptAt }}
            </td>
            <td
              style="
                border: 1px solid #000;
                border-bottom: 1px solid black;
                font-weight: bold;
              "
            >
              {{ $t("allocate.acceptDepart") }}
            </td>
            <td style="border: 1px solid #000; border-bottom: 1px solid black">
              {{ c.acceptDepartName }}
            </td>
            <td
              style="
                border: 1px solid #000;
                border-bottom: 1px solid black;
                font-weight: bold;
              "
            >
              {{ $t("allocate.inOperatorName") }}
            </td>
            <td style="border: 1px solid #000; border-bottom: 1px solid black">
              <span v-if="c.workflowState == 'rejected'">{{
                c.rejecterName
              }}</span>
              <span v-else>{{ c.accepterName }}</span>
            </td>
          </tr>
        </div>
      </table>
    </div>

    <el-dialog
      :title="$t('action.accept')"
      :close-on-click-modal="false"
      :visible.sync="batchAcceptDF"
      width="70%"
    >
      <el-form
        ref="batchAcceptObjForm"
        :model="batchAcceptObj"
        label-width="90px"
      >
        <div class="float-right">
          <el-checkbox v-model="batchAcceptObj.andPickDF">{{
            $t("stock.andPick")
          }}</el-checkbox>
        </div>
        <br />
        <vxe-table
          :data="batchAcceptRecords"
          class="recordsTable"
          size="mini"
          highlight-hover-row
          :scroll-y="{ enabled: false }"
        >
          <vxe-table-column
            field="images"
            :title="$t('product.images')"
            width="85px"
          >
            <template v-slot="{ row }">
              <thumbnail :images="row.productImages_" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="serialNo"
            :title="$t('allocate.serialNo')"
            min-width="140"
          >
            <template v-slot="{ row }">
              {{ row.serialNo }}
              <div
                :class="row.type == 'in' ? 'green' : 'orange'"
                class="font10"
              >
                {{ $t("allocateTypes." + row.type) }}
              </div>
              <state-label :state="row.workflowState">
                {{ $t("allocateWorkflowState." + row.workflowState) }}
              </state-label>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="productNo"
            :title="$t('product.productNo')"
            min-width="100"
          >
            <template v-slot="{ row }">
              {{ row.productNo }}
              <div class="font10">
                {{ row.categoryName_ }}
                <span v-if="row.productBrand_ != null">/</span>
                {{ row.productBrand_ }}
              </div>
              <div>{{ row.color }} {{ row.size }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="quantity"
            :title="$t('text.quantity')"
            min-width="70"
          >
            <template v-slot="{ row }">
              {{ row.quantity }}
              <el-input v-model.trim="row._quantity" size="small" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="applyDepartName"
            :title="$t('allocate.applyDepartInfo')"
            min-width="160"
          >
            <template v-slot="{ row }">
              {{ row.applyDepartName }}
              <div class="font10">
                {{ row.applicantName }} 于 {{ row.applyAt }}
              </div>
              <raw-html-limit-number :content="row.applyRemark" :number="20" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="acceptDepartName"
            :title="$t('allocate.acceptDepartInfo')"
            min-width="100"
          >
            <template v-slot="{ row }">
              {{ row.acceptDepartName }}
              <div class="font10">
                {{ $t("menu.inventories") }}:{{ row._invMaxQuantity }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            v-if="batchAcceptObj.andPickDF == true"
            field="_shelfId"
            :title="$t('stock.shelf')"
            min-width="160"
          >
            <template v-slot="{ row, rowIndex }">
              <el-select
                size="small"
                v-model="row._shelfId"
                @change="selectAcceptAndPickShelfBatch(row, rowIndex)"
              >
                <el-option
                  v-for="shelf in row._currentRowInvShelfs"
                  :key="shelf.shelfId"
                  :label="shelf.shelfName + '(' + shelf.quantity + ')'"
                  :value="shelf.shelfId"
                />
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="action"
            :title="$t('text.action')"
            width="50"
          >
            <template v-slot="{ row, rowIndex }">
              <el-button type="text" @click="remove(row, rowIndex)" size="mini">
                {{ $t("text.remove") }}
              </el-button>
            </template>
          </vxe-table-column>
        </vxe-table>
        <br />
        <el-row>
          <el-col :span="12">
            <el-form-item
              :prop="'operateRemark'"
              :label="$t('allocate.acceptRemark')"
            >
              <el-input
                size="small"
                v-model.trim="acceptObj.operateRemark"
                type="textarea"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="batchAcceptDoing"
          size="small"
          @click="batchAcceptSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="batchAcceptDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import DateRange from "@/components/DateRange";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import RawHtml from "@/components/RawHtml";
import StateLabel from "@/components/StateLabel";

import Shop from "@/api/shop.js";
import Allocate from "@/api/allocate.js";
import Inventory from "@/api/inventory.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    RawHtmlLimitNumber,
    DateRange,
    RawHtml,
    StateLabel,
  },
  data() {
    return {
      Util: Util,
      narrows: [
        [
          {
            label: this.$t("text.workflowState"),
            items: Allocate.states.map((t) => {
              return {
                key: t,
                label: this.$t("allocateWorkflowState." + t),
                condition: { workflowState: t },
              };
            }),
          },
          {
            label: this.$t("text.type"),
            items: [
              {
                label: this.$t("allocateTypes.in"),
                key: "in",
                condition: { type: "in" },
              },
              {
                label: this.$t("allocateTypes.out"),
                key: "out",
                condition: { type: "out" },
              },
            ],
          },
        ],
        [
          {
            label: this.$t("allocate.allocateCountType"),
            items: [
              {
                label: this.$t("allocateCountTypes.pendingIn"),
                key: "pendingIn",
                condition: { countType: "pendingIn" },
              },
              {
                label: this.$t("allocateCountTypes.pendingOut"),
                key: "pendingOut",
                condition: { countType: "pendingOut" },
              },
            ],
          },
        ],
      ],
      initFilter: null,
      searchForm: {
        productNo: null,
        applyAtStartAt: null,
        applyAtEndAt: null,
        acceptAtStartAt: null,
        acceptEndAt: null,
      },
      sorter: {
        sortBy: "allocates_id",
        sortIndicator: "desc",
      },
      shops: [],
      shopsInv: [],
      shopsView: [],
      shopsManage: [],
      // 编辑
      editDF: false,
      row: null,
      rowIndex: null,
      shopsAllocate: [],
      editObj: {
        quantity: null,
        applyRemark: null,
        acceptDepartId: null,
        acceptDepartName: null,
        _applyDepartName: null,
        _type: "in",
        _maxQuantity: null,
      },
      editDoing: false,
      currentRowInvInfo: null,
      // 受理
      acceptObj: {
        id: null,
        quantity: null,
        operateRemark: null,
        _acceptDepartName: null,
        _invMaxQuantity: null,
        _maxQuantity: null,
        _unAcceptAllocateQuantity: null,
        _andPickDF: false,
        shelfId: null,
      },
      currentRowInvShelfs: [],
      acceptDoing: false,
      acceptDF: false,
      // 拒绝
      rejectDF: false,
      rejectObj: {
        operateRemark: null,
      },
      rejectDoing: false,
      // 取消
      cancelDF: false,
      cancelObj: {
        cancelReason: null,
      },
      cancelDoing: false,
      //批量受理
      batchAcceptRecords: [],
      batchAcceptObj: { andPickDF: false },
      batchAcceptDF: false,
      batchAcceptDoing: false,
    };
  },

  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });

    Shop.findByTenantId().then(function (res) {
      if (res.status === 200) {
        self.shops = res.data;
        self.shopsInv = res.data.filter((s) => s.isInventory === true);
        if (self.Permit.currentUser().admin) {
          self.shopsView = self.shopsInv;
          self.shopsManage = self.shopsInv;
        } else {
          self.shopsView = self.shopsInv.filter(
            (s) =>
              self.Permit.wmsViewShopIds().includes(s.id) &&
              s.isInventory == true
          );
          self.shopsManage = self.shopsInv.filter(
            (s) =>
              self.Permit.wmsManageShopIds().includes(s.id) &&
              s.isInventory == true
          );
        }
        if (self.shopsView.length !== 0) {
          self.narrows.push([
            {
              label: self.$t("allocate.applyDepartName"),
              items: self.shopsView.map((shop) => {
                return {
                  label: shop.name,
                  key: shop.id.toString() + "apply",
                  condition: { applyDepartId: shop.id },
                };
              }),
            },
          ]);
          self.narrows.push([
            {
              label: self.$t("allocate.acceptDepartName"),
              items: self.shopsView.map((shop) => {
                return {
                  label: shop.name,
                  key: shop.id.toString() + "accept",
                  condition: { acceptDepartId: shop.id },
                };
              }),
            },
          ]);
        }
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    batchAccept() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.batchAcceptRecords = self.selectRecords.filter(
        (s) =>
          s.type == "in" &&
          s.workflowState == "applying" &&
          (self.Permit.wmsManageShopIds().includes(s.acceptDepartId) ||
            self.Permit.currentUser().admin)
      );
      if (self.batchAcceptRecords.length === 0) {
        this.$message.error(
          this.$t("prompt.atLeastOneDataCanBatchAcceptRecords")
        );
        return;
      }
      const datas = self.batchAcceptRecords.map((row) => {
        return {
          entityId: row.id,
          productNo: row.productNo,
          color: row.color,
          size: row.size,
          shopId: row.acceptDepartId,
        };
      });
      Inventory.batchFindByProductInfo(datas).then(function (res) {
        if (res.status == 200) {
          for (let record of self.batchAcceptRecords) {
            const obj = res.data.find((r) => r.entityId == record.id);
            Vue.set(record, "_quantity", record.quantity);
            if (obj != null) {
              Vue.set(record, "_invMaxQuantity", obj.quantity - obj.totalLock);
              Vue.set(record, "_maxQuantity", obj.quantity - obj.totalLock);
              Vue.set(record, "_currentRowInvShelfs", obj.inventoryShelfs);
              Vue.set(record, "_shelfId", null);
            } else {
              Vue.set(record, "_invMaxQuantity", 0);
              Vue.set(record, "_maxQuantity", 0);
              Vue.set(record, "_currentRowInvShelfs", []);
              Vue.set(record, "_shelfId", null);
            }
          }
        } else {
          self.sysError();
        }
        self.batchAcceptDF = true;
      });
    },
    remove(row, rowIndex) {
      this.batchAcceptRecords.splice(rowIndex, 1);
    },
    selectAcceptAndPickShelfBatch(row, rowIndex) {
      const self = this;
      if (
        self.batchAcceptRecords[rowIndex]._shelfId == null ||
        self.batchAcceptRecords[rowIndex].shelfId == ""
      ) {
        return;
      }
      const obj = self.batchAcceptRecords[rowIndex]._currentRowInvShelfs.find(
        (c) => c.shelfId == self.batchAcceptRecords[rowIndex]._shelfId
      );
      if (self.batchAcceptRecords[rowIndex]._invMaxQuantity > obj.quantity) {
        self.batchAcceptRecords[rowIndex]._maxQuantity = obj.quantity;
      } else {
        self.batchAcceptRecords[rowIndex]._maxQuantity =
          self.batchAcceptRecords[rowIndex]._invMaxQuantity;
      }
    },

    batchAcceptSubmit() {
      const self = this;
      if (self.batchAcceptRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      for (let record of self.batchAcceptRecords) {
        if (
          !Util.regexQuantity(record._quantity) ||
          record._quantity > record._maxQuantity
        ) {
          self.$message({
            message: self.$t("prompt.existBeyondInvQty"),
            type: "warning",
          });
          return;
        }
      }

      const datas = self.batchAcceptRecords.map((r) => {
        return {
          id: r.id,
          quantity: r._quantity,
          operateRemark: self.batchAcceptObj.operateRemark,
          shelfId: self.batchAcceptObj.andPickDF == true ? r._shelfId : null,
        };
      });
      if (self.batchAcceptObj.andPickDF == true) {
        self.batchAcceptDF = true;
        Allocate.batchAgreeAndPick(datas).then(function (res) {
          if (res.status === 200) {
            self.sysResults(res.data);
            self.loadData();
          } else {
            self.sysError();
          }
          self.batchAcceptDF = false;
          self.batchAcceptDoing = false;
        });
      } else {
        self.batchAcceptDF = true;
        Allocate.batchAgree(datas).then(function (res) {
          if (res.status === 200) {
            self.sysResults(res.data);
            self.loadData();
          } else {
            self.sysError();
          }
          self.batchAcceptDF = false;
          self.batchAcceptDoing = false;
        });
      }
    },
    // 打印
    print(type) {
      this.printFunction(type);
    },
    //　下载
    download(type) {
      const self = this;
      if (type === "checked") {
        if (!self.downloadChecked(self.selectRecords)) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: self.selectRecords.map((p) => p.id),
        };
        self.downloadData(data);
      } else {
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      Allocate.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    // 申请调入 取消
    cancel(row, rowIndex) {
      this.row = row;
      this.rowIndex = rowIndex;
      this.cancelObj.cancelReason = null;
      this.cancelDoing = false;
      this.cancelDF = true;
    },
    cancelSubmit() {
      const self = this;
      self.cancelDoing = true;
      Allocate.cancel(self.row.id, self.cancelObj).then(function (res) {
        if (res.status === 200) {
          self.cancelDoing = false;
          self.cancelDF = false;
          self.sysResult(res.data);
          // self.$message({
          //   message: self.$t("prompt.cancelSuccess"),
          //   type: "success",
          // });
          self.records[self.rowIndex].cancelName =
            self.Permit.currentUser().name;
          self.records[self.rowIndex].cancelAt = Util.formatDate(new Date());
          self.records[self.rowIndex].cancelReason =
            self.cancelObj.cancelReason;
          self.records[self.rowIndex].workflowState = "cancel";
          self.$eventHub.$emit("allocateCancel");
        } else {
          self.sysError();
        }
      });
    },
    // 申请调入 拒绝
    reject(row, rowIndex) {
      this.row = row;
      this.rowIndex = rowIndex;
      this.rejectObj.operateRemark = null;
      this.rejectDoing = false;
      this.rejectDF = true;
    },
    rejectSubmit() {
      const self = this;
      self.rejectDoing = true;
      Allocate.reject(self.row.id, self.rejectObj).then(function (res) {
        if (res.status === 200) {
          self.rejectDoing = false;
          self.rejectDF = false;
          self.$message({
            message: self.$t("prompt.rejectSuccess"),
            type: "success",
          });
          self.records[self.rowIndex].rejecterName =
            self.Permit.currentUser().name;
          self.records[self.rowIndex].rejectAt = Util.formatDate(new Date());
          self.records[self.rowIndex].rejectReason =
            self.rejectObj.operateRemark;
          self.records[self.rowIndex].workflowState = "rejected";
          self.$eventHub.$emit("allocateReject");
        } else {
          self.sysError();
        }
      });
    },
    //申请调入 受理
    accept(row, rowIndex) {
      const self = this;
      self.row = row;
      self.rowIndex = rowIndex;
      self.acceptObj.id = row.id;
      self.acceptObj.quantity = row.quantity;
      self.acceptObj.operateRemark = row.operateRemark;
      self.acceptObj._acceptDepartName = row.acceptDepartName;
      self.acceptObj._andPickDF = false;
      self.acceptObj.shelfId = null;

      self.currentRowInvShelfs = [];
      self.currentRowInvInfo = null;
      const obj = {
        productNo: row.productNo,
        color: row.color,
        size: row.size,
        shopId: row.acceptDepartId,
      };
      axios
        .all([
          Inventory.findByProductInfo(obj),
          Allocate.unacceptSumByProductInfo(obj),
        ])
        .then(
          axios.spread(function (inventory, unAcceptAllocateCount) {
            if (inventory.data.code == 200) {
              self.currentRowInvInfo = inventory.data.entity;
              let maxQty =
                self.currentRowInvInfo.quantity -
                self.currentRowInvInfo.totalLock;
              self.acceptObj._invMaxQuantity = maxQty;
              self.acceptObj._maxQuantity = maxQty;
              self.currentRowInvShelfs = inventory.data.entity.inventoryShelfs;
            } else {
              self.sysError();
            }
            if (unAcceptAllocateCount.status == 200) {
              self.acceptObj._unAcceptAllocateQuantity =
                unAcceptAllocateCount.data - self.row.quantity;
            } else {
              self.sysError();
            }
            self.acceptDoing = false;
            self.acceptDF = true;
          })
        );
    },
    selectAcceptAndPickShelf() {
      const self = this;
      if (self.acceptObj.shelfId != null && self.acceptObj.shelfId != "") {
        const obj = self.currentRowInvShelfs.find(
          (c) => c.shelfId == self.acceptObj.shelfId
        );
        if (self.acceptObj._invMaxQuantity > obj.quantity) {
          self.acceptObj._maxQuantity = obj.quantity;
        } else {
          self.acceptObj._maxQuantity = self.acceptObj._invMaxQuantity;
        }
      }
    },
    acceptSubmit() {
      const self = this;
      self.$refs.acceptObjForm.validate((valid) => {
        if (valid) {
          if (
            !Util.regexQuantity(self.acceptObj.quantity) ||
            self.acceptObj.quantity > self.acceptObj._maxQuantity
          ) {
            self.$message({
              message: self.$t("rules.beyondMaxQty", [
                self.acceptObj._maxQuantity,
              ]),
              type: "warning",
            });
            return;
          }
          if (self.acceptObj._andPickDF) {
            self.acceptDoing = true;
            Allocate.agreeAndPick(self.row.id, self.acceptObj).then(function (
              res
            ) {
              if (res.status === 200) {
                self.acceptDF = false;
                self.acceptDoing = false;
                self.sysResult(res.data);
                if (res.data.type == "success") {
                  self.records[self.rowIndex].quantity =
                    self.acceptObj.quantity;
                  self.records[self.rowIndex].acceptAndPickRemark =
                    self.acceptObj.operateRemark;
                  self.records[self.rowIndex].workflowState = "outed";
                  self.$eventHub.$emit("allocateAgreeAndPick");
                }
              } else {
                self.sysError();
              }
            });
          } else {
            self.acceptObj.shelfId == null;
            self.acceptDoing = true;
            Allocate.agree(self.row.id, self.acceptObj).then(function (res) {
              if (res.status === 200) {
                self.sysResult(res.data);
                self.acceptDF = false;
                self.acceptDoing = false;
                if (res.data.type == "success") {
                  self.records[self.rowIndex].quantity =
                    self.acceptObj.quantity;
                  self.records[self.rowIndex].acceptRemark =
                    self.acceptObj.operateRemark;
                  self.records[self.rowIndex].workflowState = "picking";
                  self.$eventHub.$emit("allocateAgree");
                }
              } else {
                self.sysError();
              }
            });
          }
        } else {
          return false;
        }
      });
    },

    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Allocate.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
            self.$eventHub.$emit("allocateDelete");
          } else {
            self.sysError();
          }
        });
      }
    },

    // 编辑
    edit(row, rowIndex) {
      const self = this;
      self.row = row;
      self.rowIndex = rowIndex;
      self.editObj.quantity = row.quantity;
      self.editObj.applyRemark = row.applyRemark;
      self.editObj.acceptDepartId = row.acceptDepartId;
      self.editObj.acceptDepartName = row.acceptDepartName;
      self.editObj._applyDepartName = row.applyDepartName;
      self.editObj._type = row.type;
      self.currentRowInvInfo = null;
      let obj = {
        productNo: row.productNo,
        color: row.color,
        size: row.size,
      };
      Inventory.shopQuantityCount(obj).then(function (res) {
        const invInfos = res.data;
        if (
          invInfos.find((ii) => ii.shopId === self.row.applyDepartId) != null
        ) {
          self.currentRowInvInfo = invInfos.find(
            (ii) => ii.shopId === self.row.applyDepartId
          );
        }

        if (self.editObj._type === "in") {
          invInfos.forEach(
            (ii) =>
              (ii.text =
                ii.shopName +
                "(库存:" +
                ii.quantity +
                "/锁定:" +
                ii.totalLock +
                ")")
          );
          self.shopsAllocate = invInfos.filter(
            (ii) => ii.shopId !== self.row.applyDepartId
          );
          const selectedAcceptDepart = self.shopsAllocate.find(
            (ii) => ii.shopId === self.row.acceptDepartId
          );
          self.editObj._maxQuantity =
            selectedAcceptDepart != null ? selectedAcceptDepart.quantity : 0;
        } else {
          const shopsAllocate = self.shops.filter(
            (ii) =>
              ii.shopId !== self.row.applyDepartId && ii.isInventory === true
          );
          self.shopsAllocate = shopsAllocate.map((ii) => {
            return {
              text: ii.name,
              shopName: ii.name,
              shopId: ii.id,
              quantity:
                self.currentRowInvInfo != null
                  ? self.currentRowInvInfo.quantity
                  : 0,
            };
          });
          self.editObj._maxQuantity = self.currentRowInvInfo.quantity;
        }
        self.editDoing = false;
        self.editDF = true;
      });
    },
    checkAllocateQuantityEdit() {
      const self = this;
      if (
        self.editObj.acceptDepartId != null &&
        self.editObj.quantity != null
      ) {
        const selectedAcceptDepart = self.shopsAllocate.find(
          (ii) => ii.shopId === self.editObj.acceptDepartId
        );
        if (self.editObj._type === "in") {
          self.editObj._maxQuantity = selectedAcceptDepart.quantity;
        } else {
          self.editObj._maxQuantity = self.currentRowInvInfo.quantity;
        }
      }
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.editObj.quantity)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          if (self.editObj.quantity > self.editObj._maxQuantity) {
            self.$message({
              message: self.$t("rules.beyondMaxQty", [
                self.editObj._maxQuantity,
              ]),
              type: "warning",
            });
            return;
          }
          self.editObj.acceptDepartName = self.shopsAllocate.find(
            (is) => is.shopId === this.editObj.acceptDepartId
          ).shopName;
          self.editDoing = true;
          Allocate.update(self.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.records[self.rowIndex].quantity = self.editObj.quantity;
              self.records[self.rowIndex].applyRemark =
                self.editObj.applyRemark;
              self.records[self.rowIndex].acceptDepartId =
                self.editObj.acceptDepartId;
              self.records[self.rowIndex].acceptDepartName =
                self.editObj.acceptDepartName;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //-----
    dataProvider(params) {
      return Allocate.search(params);
    },
  },
};
</script>
